export const PERIOD_OPTIONS = [
  { key: 'all',       labelKey: 'period_all' },
  { key: 'ytd',       labelKey: 'period_ytd' },
  { key: 'last_year', labelKey: 'period_last_year' },
  { key: 'quarter',   labelKey: 'period_quarter' },
];

// Single-series marks (bars, sparklines) use the brand primary/accent —
// only "Mix destinations" needs a real categorical set (validated for CVD safety).
export const CHART_PRIMARY = '#0F3D5C';
export const CHART_ACCENT = '#F39200';

// Color follows the region's identity, never its rank in the sorted list —
// otherwise the same region could repaint a different color across periods.
const OTHER_REGION_COLOR = '#64748b';
export const REGION_COLOR_BY_NAME = {
  'Europe du Nord': '#2563eb',
  "Europe de l'Ouest": '#0d9488',
  'UK & Irlande': '#d97706',
  'Autres régions': OTHER_REGION_COLOR,
};

export function regionColor(region) {
  return REGION_COLOR_BY_NAME[region] || OTHER_REGION_COLOR;
}

export function fmtAmount(amount, locale) {
  if (amount == null) return '—';
  return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'fr-FR', {
    maximumFractionDigits: 0,
  }).format(amount) + ' €';
}

export function fmtCompactAmount(amount, locale) {
  if (amount == null) return '—';
  return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'fr-FR', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(amount) + ' €';
}

export function fmtTons(tons, locale) {
  if (tons == null) return '—';
  return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'fr-FR', {
    maximumFractionDigits: 0,
  }).format(tons) + ' t';
}

export function fmtPct(pct, digits = 1) {
  if (pct == null) return '—';
  return `${pct.toFixed(digits)}%`;
}

// Rounds `roughMax` up to a "nice" step (1/2/5 * 10^n) so axis ticks land on
// clean numbers, then returns evenly spaced ticks from 0 (or floor) to that max.
export function niceScale(maxValue, tickCount = 4, minValue = 0) {
  const safeMax = Math.max(maxValue, 1);
  const span = safeMax - minValue || 1;
  const roughStep = span / tickCount;
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
  const normalized = roughStep / magnitude;
  let niceNormalized;
  if (normalized <= 1) niceNormalized = 1;
  else if (normalized <= 2) niceNormalized = 2;
  else if (normalized <= 5) niceNormalized = 5;
  else niceNormalized = 10;
  const step = niceNormalized * magnitude;
  const niceMin = Math.floor(minValue / step) * step;
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => niceMin + i * step);
  return { min: niceMin, max: ticks[ticks.length - 1], step, ticks };
}

export function fmtMonth(monthKey, locale) {
  if (!monthKey) return '';
  const [year, month] = monthKey.split('-').map(Number);
  return new Date(year, month - 1, 1).toLocaleDateString(locale === 'en' ? 'en-GB' : 'fr-FR', {
    month: 'short',
  });
}
